import React, { useState } from "react";
import InputDate from "components/atoms/InputDate";
import InputRadio from "components/atoms/InputRadio";
import InputSelect from "components/atoms/InputSelect";
import { MonthOptions } from "utils/constant";
import { generateMonthOptions } from "utils/common";
import moment from "moment";

const PeriodeFilter = ({
  periodeLaporan,
  setPeriodeLaporan,
  periodeLaporanValue,
  setPeriodeLaporanValue,
}) => {
  const [selectedStart, setSelectedStart] = useState("");
  const [selectedEnd, setSelectedEnd] = useState("");

  const renderInput = () => {
    if (periodeLaporan === "monthly") {
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
          <div style={{ flex: "1" }}>
            <InputDate
              value={periodeLaporanValue}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                setPeriodeLaporanValue((prevPeriode) => ({
                  ...prevPeriode,
                  year: selectedYear,
                }));
              }}
              placeholder={"Pilih tahun"}
              dateFormat={"YYYY"}
            />
          </div>
          <div style={{ flex: "1" }}>
            <InputSelect
              data={MonthOptions}
              isClearable={false}
              placeholder={"Bulan Mulai"}
              value={
                MonthOptions.find(
                  (e) => e.value === periodeLaporanValue.month_start,
                ) ?? ""
              }
              onChange={(e) => {
                setPeriodeLaporanValue((prev) => {
                  const { month_end, ...rest } = prev;
                  return { ...rest, month_start: e.value };
                });
                setSelectedStart(e.value);
                setSelectedEnd("");
              }}
            />
          </div>
          <div style={{ flex: "1" }}>
            <InputSelect
              data={generateMonthOptions(periodeLaporanValue.month_start)}
              isClearable={false}
              placeholder={"Bulan Akhir"}
              onChange={(e) => {
                setPeriodeLaporanValue((prev) => ({
                  ...prev,
                  month_end: e.value,
                }));
                setSelectedEnd(e.value);
              }}
              value={
                generateMonthOptions(periodeLaporanValue.month_start)?.find(
                  (item) => item.value === selectedEnd,
                ) || ""
              }
            />
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <InputRadio
        name={`level_${periodeLaporan}`}
        isRequired
        options={[
          { label: "Bulanan", value: "monthly" },
        ]}
        onChange={(e) => {
          setPeriodeLaporan(e.target.value);
          setPeriodeLaporanValue("");
          setSelectedStart("");
          setSelectedEnd("");
        }}
        selectedOption={periodeLaporan}
      />
      <div className="advanced-filter">{renderInput()}</div>
    </>
  );
};

export default PeriodeFilter;
